import { pageBtn } from "./communicationError.styles";

interface Props {
  n: number;
  current: number;
  onClick: (n: number) => void;
}

export default function PageBtn({ n, current, onClick }: Props) {
  return (
    <button onClick={() => onClick(n)} style={pageBtn(n === current)}>
      {n}
    </button>
  );
}